module.exports = __webpack_public_path__ + "static/media/signage-industrial-img5.25c1db7b.jpg";